module.exports = __webpack_public_path__ + "img/navigation-menu.968261b3.svg";